<template>
    <div class="pipeline_toggler">
        <!-- {{ groupOptions }} -->
        <!-- {{ options }} -->
        <!-- {{ btn.state  }} -->
        <!--        <pre class="text-xs text-red-500">defaultView (from prop): {{ defaultView }}</pre>-->
        <button
            v-for="(btn, index) in groupOptions"
            :key="index"
            :disabled="disabled"
            class="pipeline_toggler_btn"
            :class="btn.state ? 'active' : ''"
            @click="(onPress(index), btnToggle(btn.emits))"
        >
            <!-- {{ btn }} -->
            <template v-if="isTextOnly">
                <span class="text-sm">{{ btn.text }}</span>
            </template>
            <template v-else-if="isTextWithIcon">
                <fa :icon="['fal', btn.icon]" />
                <span>{{ btn.text }}</span>
            </template>
            <template v-else>
                <fa :icon="['fal', btn.icon]" />
            </template>
        </button>
    </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useBoardStore } from "@/stores/boardStore";
import { chatroomStatus } from "@/stores/messagesStore";

const emit = defineEmits(["btnToggle"]);
const props = defineProps({
    options: {
        type: Array,
        default: () => [],
        required: true,
    },
    isTextOnly: {
        type: Boolean,
        default: false,
    },
    isTextWithIcon: {
        type: Boolean,
        default: false,
    },
    isActive: {
        type: String,
        default: "",
    },
    defaultView: {
        type: String,
        default: "",
    },
    disabled:{
        type: Boolean,
        default: false
    }
});

console.log("defaultView prop:", props.defaultView);
console.log("props object:", props);

const groupOptions = computed(() => {
    return props.options;
});

const btnToggle = (value) => {
    chatroomStatus.status = value;
    emit("btnToggle", value);
};

const onPress = (i) => {
    // this.buttons.forEach((b, index) => b.state = i === index)
    groupOptions.value.map((b, index) => (b.state = i === index));
};

watch(
    () => props.defaultView,
    (newValue) => {
        if (newValue) {
            console.log("Updated defaultView:", newValue);
            groupOptions.value.forEach((b) => (b.state = false));
            groupOptions.value.forEach((b) => {
                b.state = newValue === b.emits;
            });
            btnToggle(newValue);
        }
    },
    { immediate: true }, // Runs immediately on mount
);

/*onMounted(() => {
    if (props.defaultView) {
        groupOptions.value.map((b, index) => (b.state = false));
        groupOptions.value.map((b, index) => (b.state = props.defaultView === b.emits));
    }

    // [todo]: we should remove this function here on onMounted!
    btnToggle();
});*/
</script>

<style scoped>
.pipeline_toggler {
    @apply border border-white text-gray-500 dark:text-gray-400 bg-gray-100 sm:bg-transparent p-1 sm:p-0 rounded-full sm:rounded inline-flex dark:border-black-500 dark:bg-black-900 max-h-8;
}

.pipeline_toggler_btn {
    @apply text-lg text-gray-500 dark:text-gray-400 px-3 h-[30px] border border-transparent rounded-full sm:rounded inline-flex items-center justify-center;
}

.pipeline_toggler_btn svg {
    @apply text-xl;
}

.pipeline_toggler_btn:last-of-type {
    @apply mr-0;
}

.pipeline_toggler_btn.active {
    @apply bg-white text-black-500 h-[30px] px-3 inline-flex items-center justify-center border rounded-full sm:rounded text-lg pointer-events-none dark:text-white dark:bg-black-500 dark:border-transparent;
}
.pipeline_toggler_btn:first-of-type.active {
    /* @apply border-r border-l-0 border-t-0 border-b-0; */
}
.pipeline_toggler_btn:last-of-type.active {
    /* @apply border-l border-r-0 border-t-0 border-b-0; */
}
</style>
